import { createMuiTheme } from '@material-ui/core/styles'

import { palette } from 'civic-champs-shared/config/palette'

export const muiTheme = createMuiTheme({
  typography: {
    fontFamily: ['Open Sans'].join(','),
    useNextVariants: true,
  },

  palette: {
    primary: { main: palette.main.secondaryLight },
    secondary: { main: palette.main.primary },

    background: {
      default: '#ffffff',
      gray: '#efefef',
      green: palette.background.green,
      blue: '#eff4fd',
      yellow: '#fef0b2',
      warning: '#ffe2d8',
    },

    borders: {
      error: palette.border.red,
    },

    success: { main: '#008000', light: '#98FB98' },
    danger: { main: '#ff6f3e', dark: '#b24d2b' },

    accent: {
      yellowGreen: {
        main: palette.background.green,
        dark: palette.background.darkGreen,
        light: palette.background.lightGreen,
      },
      lightBlue: { main: '#add7f3', dark: '#82a4ba' },
    },

    neutral: {
      main: '#999999',
      darkGray: '#3d3d3d',
      black: '#000000',
      white: palette.main.default,
      gray: '#808080',
      grayDark: palette.text.grayDark,
      lightGray: '#cccccc',
    },
  },
  drawer: {
    width: 242,
    icon: {
      halfWidth: 12,
    },
  },
})
